const ERROR_CODES = {
  decryptionError: 1111,
};

class DecryptionError extends Error {
  code: number;
  details: unknown;
  timestamp: unknown;

  constructor(message: string, code: number, details?: unknown) {
    super(message);
    this.name = 'CustomError';
    this.code = code;
    this.details = details;
    this.timestamp = new Date();

    Error.captureStackTrace(this, this.constructor);
  }
}

export {ERROR_CODES, DecryptionError};
